import { useMemo, useState } from "react";
import useSWR from "swr";
import { getFetcher } from "../../../services/api";
import IsValidIcon from "../../../components/elements/isValidIcon";
import useListCompany from "../../useListCompany";
import { month } from "../../../enums/month";
import ReportStatusBadge from "../../../components/elements/ReportStatusBadge";
import ModalDetailProduction from "../../../components/fragments/admin/report/production/ModalDetailProduction";
import ModalEditProduction from "../../../components/fragments/admin/report/production/ModalEditProduction";
import { useSelectedCompany } from "../../useSelectedCompany";
import useActivePeriodSelection from "../../useActivePeriodSelection";

export default function useTableProduction() {
  const [selectedCompany, setSelectedCompany] = useSelectedCompany();
  const [selectedMaterial, setSelectedMaterial] = useState(null);

  /**
   * Periode default = periode aktif TERLAMA yang laporan produksi-nya belum
   * selesai untuk perusahaan ini. Logikanya ada di hook bersama
   * useActivePeriodSelection, dipakai kelima modul pelaporan dengan
   * resourcePath masing-masing.
   */
  const { selectedPeriod, setSelectedPeriod, dataPeriods, isLoadingPeriods } = useActivePeriodSelection(
    selectedCompany?.value,
    "pelaporan-b3-dihasilkan",
  );
  const { dataCompany, isLoadingCompany } = useListCompany();

  const { data, isLoading, mutate } = useSWR(selectedCompany?.value && selectedPeriod?.value ? `/api/pelaporan-b3-dihasilkan/search?returnAll=true&companyId=${selectedCompany.value}&periodId=${selectedPeriod.value}` : null, getFetcher);

  const columnsTableActivePeriod = useMemo(
    () => [
      { field: "id", headerName: "ID", valueGetter: (value, row) => row.bulan },
      { field: "perusahaan", headerName: "Perusahaan", valueGetter: (value, row) => row?.company?.name },
      { field: "jumlahB3Dihasilkan", headerName: "Jumlah Produksi", valueGetter: (value, row) => `${row.jumlahB3Dihasilkan} Kg` },
      { field: "periode", headerName: "Periode", valueGetter: (value, row) => row.period.name },
      { field: "bulan", headerName: "Bulan", valueGetter: (value, row) => month[row.bulan - 1] },
      {
        field: "status",
        headerName: "Status",
        renderCell: (params) => {
          const { status, jumlahB3Dihasilkan, laporanTersedia } = params.row;

          // Logika menentukan status Disimpan
          let computedStatus = status;
          if (!status || status === null) {
            if ((jumlahB3Dihasilkan && jumlahB3Dihasilkan !== 0 && laporanTersedia === true) || (jumlahB3Dihasilkan === 0 && laporanTersedia === false)) {
              computedStatus = "Disimpan";
            }
          }

          return <ReportStatusBadge status={computedStatus} />;
        },
        sortable: false,
        filterable: false,
      },
      {
        field: "isFinalized",
        headerName: "Finalisasi",
        renderCell: (params) => (
          <div className="flex mt-1">
            <IsValidIcon value={params.row.isFinalized} validMessage="Sudah Finalisasi" invalidMessage="Belum Finalisasi" />
          </div>
        ),
        sortable: false,
        filterable: false,
      },
      {
        field: "action",
        headerName: "Aksi",
        renderCell: (params) => (
          <div className="flex items-center gap-1">
            <ModalDetailProduction item={params.row} />
            {!params.row.isFinalized && <ModalEditProduction data={params.row} mutate={mutate} />}
          </div>
        ),
        sortable: false,
        filterable: false,
      },
    ],
    [mutate]
  );

  return {
    dataFetch: {
      data,
      isLoading,
      mutate,
      dataCompany,
      isLoadingCompany,
      dataPeriods,
      isLoadingPeriods,
    },
    state: {
      selectedCompany,
      setSelectedCompany,
      selectedMaterial,
      setSelectedMaterial,
      selectedPeriod,
      setSelectedPeriod,
    },
    columnsTableActivePeriod,
  };
}